export const countryConstants = ['USA', 'US'];
